var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeigraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 65,
    viewBox: "0 0 174 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.46244 64.9998C1.46244 64.9998 1.1778 17.92 1.46244 17.5237C3.58263 14.5722 6.55361 11.7316 8.66719 11.5278C12.2632 11.1812 14.313 15.8866 18.4451 15.8866C22.5771 15.8866 26.8071 11.8496 32.0826 11.5278C37.3581 11.206 40.6352 14.2495 45.2799 14.2495C49.9246 14.2495 55.2478 2.78975 60.4403 2.78975C65.6327 2.78975 70.6091 20.7979 77.5445 20.7979C84.4799 20.7979 85.887 5.5383 90.2483 5.5383C94.6095 5.5383 97.5143 10.9344 101.704 11.2004C105.893 11.4664 105.893 15.8866 109.423 15.8866C112.953 15.8866 118.007 1.34961 123.569 1.34961C129.132 1.34961 135.556 11.6749 139.533 11.6749C143.509 11.6749 141.329 4.42686 146.036 4.42686C150.743 4.42686 147.282 10.873 151.99 11.2004C156.699 11.5278 160.534 14.2495 165.113 14.2495C166.434 14.2495 168.247 13.6608 169.569 12.0023C170.891 10.3438 172.082 7.67861 172.082 7.67861H172.662C172.662 7.67861 172.662 8.8818 172.662 9.22946C172.662 13.0293 172.662 64.9998 172.662 64.9998H1.46244Z",
    fill: "url(#paint0_linear_4064_69192)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33594 20.2721C1.33594 20.2721 4.96557 13.5408 8.58237 13.1278C12.1992 12.7147 14.2608 18.3215 18.4168 18.3215C22.5728 18.3215 26.8273 13.5113 32.1333 13.1278C37.4393 12.7443 40.7354 16.3708 45.407 16.3708C50.0785 16.3708 55.4325 2.71599 60.655 2.71599C65.8775 2.71599 70.8827 24.1735 77.8582 24.1735C84.8337 24.1735 86.249 5.99101 90.6355 5.99101C95.022 5.99101 97.9436 12.8108 102.157 13.1278C106.371 13.4448 106.091 18.3215 109.921 18.3215C113.752 18.3215 118.034 1 123.629 1C129.223 1 135.019 13.1278 139.018 13.1278C143.017 13.1278 141.476 4.66668 146.21 4.66668C150.944 4.66668 148.101 13.1278 152.735 13.1278C157.369 13.1278 160.81 16.3708 165.416 16.3708C170.022 16.3708 172.662 8.55738 172.662 8.55738",
    stroke: "#EA3A7A",
    strokeWidth: 1.52509
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4064_69192",
    x1: 1.32062,
    y1: 1.34961,
    x2: 1.32062,
    y2: 64.9998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC0D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB2CE",
    stopOpacity: 0.01
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeigraph);
export default __webpack_public_path__ + "static/media/Weigraph.e315683e88e4810c5bb33e03a41d1ef1.svg";
export { ForwardRef as ReactComponent };